import { render, staticRenderFns } from "./company-avatar-cropper-modal.vue?vue&type=template&id=6a897244"
import script from "./company-avatar-cropper-modal.vue?vue&type=script&lang=js"
export * from "./company-avatar-cropper-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports